import { Box, Typography } from '@mui/material';
import React from 'react';
import { sxConfig } from './calendarStyle';

const TooltipContent = ({ eventInfo }) => {
  const task = eventInfo?.event?.extendedProps;

  return (
    <Box>
      <Box sx={sxConfig.tooltipContent}>
        <Typography sx={sxConfig.tooltipContentFirstTyp}>További felelősök:</Typography>
        <Typography>{task?.taskListRespPerson?.map((rp) => rp.respUser?.nickName).join(', ')}</Typography>
      </Box>
    </Box>
  );
};

export default TooltipContent;
